/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useState } from 'react';
import {
  Grid,
  Table,
  TableHeaderRow,
  TableEditColumn,
} from '@devexpress/dx-react-grid-material-ui';
import { Box, fade, Paper, Typography, withStyles } from '@material-ui/core';
import { DataTypeProvider, EditingState } from '@devexpress/dx-react-grid';
import { CommandSmall } from './CommandSmall';
import { Getter } from '@devexpress/dx-react-core';
import PopupEditing from './PopupEditing';
import { getColumns } from '../common/columns';
import useWindowDimensions from '../hooks/useWindowDimensions';
import PopupHritem from '../pubups/PopupHritem';
import { currencyFormatterEmpty, sentShowFormatter } from './colorFormat';

export const getRowId = (row: any) => row.index;

const IndexProvider = (props) => (
  <DataTypeProvider
    formatterComponent={({ value }) => (
      <Typography variant="subtitle2">{Number(value) + 1}</Typography>
    )}
    {...props}
  />
);

const styles = (theme) => ({
  tableStriped: {
    '& tbody tr:nth-of-type(odd)': {
      backgroundColor: fade(theme.palette.primary.main, 0.1),
    },
  },
});

const TableComponentBase = ({ classes, ...restProps }) => (
  <Table.Table {...restProps} className={classes.tableStriped} />
);

export const TableComponent = withStyles(styles, { name: 'TableComponent' })(
  TableComponentBase
);

export default function HritemsTable({
  rows,
  removeItem,
  editItem,
  isRTL,
  words,
  user,
  height = 400,
}: any) {
  const col = getColumns({ isRTL, words });
  const { isMobile } = useWindowDimensions();
  const [columns] = useState([
    { name: 'index', title: words.no },
    col.employee,
    col.contract,
    { name: 'isWorking', title: isRTL ? 'حاضر' : 'Present' },
    { name: 'isAbsent', title: isRTL ? 'غائب' : 'Absent' },
    { name: 'overtime', title: isRTL ? 'اضافي' : 'Overtime' },
    { name: 'deduction', title: isRTL ? 'خصم' : 'Deduction' },
    { name: 'desc', title: words?.description },
  ]);

  const [tableColumnExtensions]: any = useState([
    { columnName: 'index', width: 50 },
    { columnName: col.employee.name, width: 200 },
    { columnName: col.contract.name, width: 180 },
    { columnName: 'isWorking', width: 100 },
    { columnName: 'isAbsent', width: 100 },
    { columnName: 'overtime', width: 100 },
    { columnName: 'deduction', width: 100 },
    { columnName: 'desc', width: 200 },
  ]);

  const commitChanges = async ({ deleted }) => {
    if (deleted) {
      const index = deleted[0];
      removeItem(index);
    }
  };

  const renderEmpty = () => {
    return <Box display="flex"></Box>;
  };

  const addAction = () => {
    //
  };

  return (
    <Paper
      style={{
        overflow: 'auto',
        margin: 10,
        height,
      }}
    >
      {rows && (
        <Grid rows={rows} columns={columns} getRowId={getRowId}>
          <EditingState onCommitChanges={commitChanges} />

          <Table
            noDataCellComponent={renderEmpty}
            columnExtensions={tableColumnExtensions}
            tableComponent={TableComponent}
            rowComponent={(props: any) => (
              <Table.Row {...props} style={{ height: 40 }}></Table.Row>
            )}
          />
          <TableHeaderRow
            titleComponent={({ children }) => {
              return (
                <Typography style={{ fontSize: 14, fontWeight: 'bold' }}>
                  {children}
                </Typography>
              );
            }}
          />
          <IndexProvider for={['index']} />
          <DataTypeProvider
            for={['overtime', 'deduction']}
            formatterComponent={currencyFormatterEmpty}
          ></DataTypeProvider>
          <DataTypeProvider
            for={['isWorking', 'isAbsent']}
            formatterComponent={sentShowFormatter}
          ></DataTypeProvider>
          <TableEditColumn
            showDeleteCommand
            showEditCommand
            commandComponent={CommandSmall}
          ></TableEditColumn>
          <PopupEditing addAction={addAction} editAction={editItem}>
            <PopupHritem user={user} isRTL={isRTL} words={words}></PopupHritem>
          </PopupEditing>
          <Getter
            name="tableColumns"
            computed={({ tableColumns }) => {
              const result = [
                {
                  key: 'editCommand',
                  type: TableEditColumn.COLUMN_TYPE,
                  width: isMobile ? 100 : 120,
                },
                ...tableColumns.filter(
                  (c: any) => c.type !== TableEditColumn.COLUMN_TYPE
                ),
              ];
              return result;
            }}
          />
        </Grid>
      )}
    </Paper>
  );
}
